import React from 'react';
import { View, FlatList, Text, StyleSheet, ScrollView } from 'react-native';
import ShimmerPlaceholder from 'react-native-shimmer-placeholder';
import LinearGradient from 'react-native-linear-gradient';
import { useCssStyle } from '../../../customHook/getCssStyle';
import CustomFlatList from '../../customFlatList';

const DefaultSkeleton = () => {

  const getStyles = useCssStyle();

  const renderSkeletonItem = () => {
    return (
      <View style={getStyles(['list_itemContainer', 'widgetSkeleton_itemContainer'])}>

        <ShimmerPlaceholder
          LinearGradient={LinearGradient}
          style={getStyles(['list_itemContainer_image', 'widgetSkeleton_itemContainer_image'])}
        />

        <View style={getStyles(['list_itemContainer_textContainer', 'widgetSkeleton_itemContainer_textContainer'])}>
          <ShimmerPlaceholder
            LinearGradient={LinearGradient}
            style={getStyles(['list_itemContainer_textContainer_title', 'widgetSkeleton_itemContainer_textContainer_title'])}
          />
          <ShimmerPlaceholder
            LinearGradient={LinearGradient}
            style={getStyles(['list_itemContainer_textContainer_subtitle', 'widgetSkeleton_itemContainer_textContainer_subtitle'])}
          />
          <ShimmerPlaceholder
            LinearGradient={LinearGradient}
            style={getStyles(['list_itemContainer_textContainer_title', 'widgetSkeleton_itemContainer_textContainer_title'])}
          />
        </View>
      </View>
    );
  };

  const renderHeader = () => {


    return (
      <View style={getStyles(['widgetmainContainerHeaderContainer', 'widgetSkeletonHeaderContainer'])}>
        <ShimmerPlaceholder
          LinearGradient={LinearGradient}
          style={getStyles(['widgetmainContainerHeaderImg', 'widgetSkeletonHeaderImg'])}
        />
      </View>
    )
  }

  return (
    <View style={getStyles(['widgetRootContainer', 'widgetSkeletonRootContainer'])}>
      <View style={getStyles(['widgetmainContainer', 'widgetSkeletonMainContainer'])}>
        {renderHeader()}
        <View style={getStyles(['widgetmainContainerChildContainer', 'widgetSkeletonMainContainerChildContainer'])}>
          {renderSkeletonItem()}
          {renderSkeletonItem()}
          {renderSkeletonItem()}
          {renderSkeletonItem()}
          {renderSkeletonItem()}
          {renderSkeletonItem()}
          {renderSkeletonItem()}
          {renderSkeletonItem()}
          {renderSkeletonItem()}
          {renderSkeletonItem()}
        </View>
      </View>
    </View>
  );
};

export default DefaultSkeleton;
